module.exports = __webpack_public_path__ + "img/icon-ratings-light.9fb67224.svg";